var _circle, _path, _path2, _rect, _path3, _path4, _line, _line2, _line3, _line4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpraying(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#238E28",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3555 27.1397V23.3062L31.2001 21.0701H18.4835L15.7537 23.3062V27.1397",
    stroke: "#238E28",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.318 24.7118L31.1172 21.0701H18.0676L19.7584 24.7118H29.318Z",
    stroke: "#238E28",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 1,
    width: 16.4273,
    height: 4.40948,
    rx: 2.20474,
    transform: "matrix(-1 0 0 1 31.9453 15.0001)",
    stroke: "#238E28",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9219 16.9006C40.4742 16.9006 40.9219 17.3483 40.9219 17.9006C40.9219 18.4529 40.4742 18.9006 39.9219 18.9006V16.9006ZM34.4592 18.9006H33.4592V16.9006H34.4592V18.9006ZM39.9219 18.9006H34.4592V16.9006H39.9219V18.9006Z",
    fill: "#238E28"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4609 16.9006H16.4609V18.9006H15.4609V16.9006ZM9.99831 18.9006C9.44603 18.9006 8.99831 18.4529 8.99831 17.9006C8.99831 17.3483 9.44603 16.9006 9.99831 16.9006V18.9006ZM15.4609 18.9006H9.99831V16.9006H15.4609V18.9006Z",
    fill: "#238E28"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 1.40356,
    y2: -1,
    transform: "matrix(4.37103e-08 1 1 -4.37103e-08 38 15.6067)",
    stroke: "#238E28",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 1.40356,
    y2: -1,
    transform: "matrix(4.37103e-08 1 1 -4.37103e-08 12.6953 15.6067)",
    stroke: "#238E28",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 2.64175,
    y2: -1,
    transform: "matrix(-1 0 0 1 39.0117 15.6067)",
    stroke: "#238E28",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 2.64175,
    y2: -1,
    transform: "matrix(-1 0 0 1 13.9336 15.6067)",
    stroke: "#238E28",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6094 27.0181L24.6094 28.6204",
    stroke: "#238E28",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6094 30.2224L24.6094 31.8247",
    stroke: "#238E28",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6094 33.4281L24.6094 35.0305",
    stroke: "#238E28",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7461 27.0187L21.1947 28.5232",
    stroke: "#238E28",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6406 30.027L20.0893 31.5316",
    stroke: "#238E28",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5391 33.0364L18.9877 34.5409",
    stroke: "#238E28",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.793 27.0183L28.3443 28.5228",
    stroke: "#238E28",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8984 30.0269L29.4498 31.5314",
    stroke: "#238E28",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30 33.0361L30.5514 34.5407",
    stroke: "#238E28",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpraying);
export default __webpack_public_path__ + "static/media/spraying.eabbcf0ac49c19b0f92a2e75224a9117.svg";
export { ForwardRef as ReactComponent };